export const antDTheme = {
  token: {
    fontFamily: 'Inter, sans-serif',
    screenXSMax: 639,
    screenSM: 640,
    screenSMMin: 640,
    screenMDMax: 1023,
    screenLG: 1024,  // Large screen
    screenLGMin: 1024,
    screenLGMax: 1279,
    screenXL: 1280,  // Large screen
    screenXLMin: 1280,
    screenXLMax: 1535,
    screenXXL: 1536,
    screenXXLMin: 1536
  },  
  components: {
    Table: {
      "headerBg": "#EDF5FF",
      "headerColor":"#1A1A1A",
      "headerSortActiveBg": "rgb(255,255,255)",
      "bodySortBg": "rgb(255,255,255)",
      "rowSelectedHoverBg": "rgba(255,255,255,0)",
      "footerBg": "rgba(250,250,250,0)"
    },
  }
  }
  